import { useState, useEffect } from "react";
import { __API_URL__ } from "../../SERVER_URL";
import axios from "axios";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import IconButton from "@mui/material/IconButton";
import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import FormControlLabel from "@mui/material/FormControlLabel";
import Checkbox from "@mui/material/Checkbox";
import EditTwoToneIcon from "@mui/icons-material/EditTwoTone";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";
import AddQuestion from "./AddQuestion";
import { useNavigate } from "react-router-dom";

const CreateSurvey = ({
  questionCount,
  setQuestionCount,
  setActiveTab,
  toast,
  GetSurveys,
  surveyId,
  setSurveyId,
  survey,
  setSurvey,
  settabChanged,
  setAddNewSurvey,
  setLoader,
}) => {
  const token = localStorage.getItem("token");
  const [allQuestion, setAllQuestion] = useState([]);
  const [disabled, setDisabled] = useState(true);
  const [newQuestion, setNewQuestion] = useState(false);
  const [editQuestion, setEditQuestion] = useState("");
  const [disableOrderNumber, setDisableOrderNumber] = useState(true);
  const [questionIndex, setQuestionIndex] = useState(-1);
  const navigate = useNavigate();

  const handleChoices = (e, index) => {
    const { label, value } = e;
    setDisableOrderNumber(false);
    const questionArray = survey?.question ? [...survey.question] : [];

    if (index >= 0 && index < questionArray.length) {
      questionArray[index] = { label: label, value: value };
      if (!questionArray[index].order) questionArray[index]["order"] = index + 1;
    } else {
      questionArray.push({
        label: label,
        value: value,
        order_number: index + 1,
      });
    }
    setSurvey({
      ...survey,
      question: questionArray,
    });

    setDisabled(false);
  };

  const handleOrderNumber = (e, index) => {
    const questionArray = survey?.question ? [...survey.question] : [];

    if (index >= 0 && index < questionArray.length) {
      questionArray[index] = {
        ...questionArray[index],
        order_number: e.target.value,
      };
    } else {
      questionArray.push({ order_number: e.target.value });
    }
    setSurvey({
      ...survey,
      question: questionArray,
    });
  };

  const handleFieldChange = (e) => {
    const { name, value } = e.target;
    setSurvey({
      ...survey,
      [name]: value,
    });
  };

  const handleAvailable = () => {
    setSurvey({
      ...survey,
      available: !survey.available,
    });
  };

  const handleAddQuestion = () => {
    const nextValue = questionCount[questionCount.length - 1] + 1;
    const updatedquestionCount = [...questionCount, nextValue];
    setQuestionCount(updatedquestionCount);
    setDisabled(true);
    setDisableOrderNumber(true);
  };

  const handleRemoveQuestion = (index) => {
    if (questionCount.length === 1) {
      toast.error("At least one question is necessary.");
    } else {
      const updatedQuestionCount = questionCount.slice();
      updatedQuestionCount.splice(index, 1);

      setQuestionCount(updatedQuestionCount);

      setSurvey((prevSurvey) => {
        const updatedQuestions = prevSurvey.question.slice();
        updatedQuestions.splice(index, 1);

        return {
          ...prevSurvey,
          question: updatedQuestions,
        };
      });
    }
  };

  const getSingleSurvey = () => {
    axios
      .get(`${__API_URL__}/api/survey/get_single_survey/${surveyId}`, {
        headers: {
          Authorization: `Token ${token}`,
        },
      })
      .then((res) => {
        setSurvey(res.data);
      });
  };

  const AllQuestionsDropdown = () => {
    axios
      .post(
        `${__API_URL__}/api/survey/dropdown_question`,
        { questions: survey?.question },
        {
          headers: {
            Authorization: `Token ${token}`,
          },
        }
      )
      .then((res) => {
        setAllQuestion(res.data);
      })
      .catch(() => {
        toast.error("Something Went Wrong");
      });
  };

  const CreateSurveySubmit = (e) => {
    e.preventDefault();
    if (surveyId) {
      axios
        .patch(
          `${__API_URL__}/api/survey/edit_survey/${surveyId}/`,
          {
            ...survey,
            available: survey?.available ? survey.available : false,
          },
          {
            headers: {
              Authorization: `Token ${token}`,
            },
          }
        )
        .then(() => {
          toast.success("Survey updated successfully!");
          GetSurveys();
          setActiveTab("viewCase");
          setSurveyId(0);
          settabChanged(false);
        })
        .catch(() => {
          toast.error("Something Went Wrong");
        });
    } else {
      axios
        .post(
          `${__API_URL__}/api/survey/create_survey/`,
          {
            ...survey,
            available: survey?.available ? survey.available : false,
          },
          {
            headers: {
              Authorization: `Token ${token}`,
            },
          }
        )
        .then(() => {
          toast.success("Survey Added successfully!");
          GetSurveys();
          setActiveTab("viewCase");
          setLoader(false);
          setSurveyId(0);
          if (setAddNewSurvey) {
            setAddNewSurvey(false);
          }
        })
        .catch(() => {
          toast.error("Something Went Wrong");
        });
    }
  };

  const handleEdit = (value) => {
    setEditQuestion(value);
    setNewQuestion(true);
  };

  const handleNewQuestion = (index) => {
    setNewQuestion(true);
    setQuestionIndex(index);
  };

  useEffect(() => {
    if (survey.question && Array.isArray(survey.question) && surveyId) {
      const newQuestionCount = Array.from(
        { length: survey.question.length },
        (_, index) => index + 1
      );
      setQuestionCount(newQuestionCount);
    }
  }, [survey]);

  useEffect(() => {
    AllQuestionsDropdown();
  }, [survey?.question]);

  useEffect(() => {
    if (surveyId) {
      getSingleSurvey();
      setDisabled(false);
      setDisableOrderNumber(false);
    }
  }, []);

  const handleCancel = () => {
    settabChanged(false);
    setSurveyId(0);
    if (setAddNewSurvey) {
      setAddNewSurvey(false);
    }
    navigate(setActiveTab("viewCase"));
  };

  const isOptEqual = (option, value) => option.value === value.value;

  return (
    <Box sx={{ maxWidth: 900, mx: "auto" }}>
      <Paper sx={{ p: 3 }}>
        <form onSubmit={CreateSurveySubmit}>
          <TextField
            label="Name"
            name="name"
            fullWidth
            margin="normal"
            size="small"
            value={survey?.name || ""}
            onChange={handleFieldChange}
            placeholder="Enter Name"
            required
            className="survey-name"
          />

          <FormControl fullWidth margin="normal" size="small">
            <InputLabel id="survey-type-label">Type</InputLabel>
            <Select
              labelId="survey-type-label"
              label="Type"
              name="type"
              value={survey?.type || ""}
              onChange={handleFieldChange}
              required
              className="survey-type"
            >
              <MenuItem value="">
                <em>Select</em>
              </MenuItem>
              <MenuItem value="Wrinkles">Wrinkles</MenuItem>
              <MenuItem value="POEM">POEM</MenuItem>
            </Select>
          </FormControl>

          <FormControlLabel
            control={
              <Checkbox
                checked={survey.available === true}
                onChange={handleAvailable}
                className="survey-available"
              />
            }
            label="Available"
          />

          <Typography variant="subtitle2" sx={{ mt: 2, mb: 1 }}>
            Question
          </Typography>

          {questionCount?.map((choice, index) => (
            <Box
              key={index}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                mb: 1,
              }}
            >
              <Box sx={{ flex: 1 }}>
                <Autocomplete
                  value={survey?.question[index] || null}
                  options={allQuestion || []}
                  getOptionLabel={(o) => o.label || ""}
                  isOptionEqualToValue={isOptEqual}
                  onChange={(_e, val) => {
                    if (val) handleChoices(val, index);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={`Question ${index + 1}`}
                      size="small"
                      className={`survey-question-${index}`}
                    />
                  )}
                />
              </Box>
              <TextField
                type="number"
                label="Order"
                size="small"
                sx={{ width: 80 }}
                inputProps={{ min: 1 }}
                name="order_number"
                value={survey?.question[index]?.order_number || ""}
                disabled={disableOrderNumber}
                required
                onChange={(e) => handleOrderNumber(e, index)}
                className={`survey-question-${index}-order`}
              />
              <IconButton
                size="small"
                onClick={() => handleEdit(survey?.question[index], index)}
                className="survey-edit"
              >
                <EditTwoToneIcon />
              </IconButton>
              <IconButton
                size="small"
                onClick={() => handleNewQuestion(index)}
                className="survey-add"
              >
                <AddIcon />
              </IconButton>
              <IconButton
                size="small"
                onClick={() => handleRemoveQuestion(index)}
                className="survey-delete"
              >
                <DeleteIcon />
              </IconButton>
            </Box>
          ))}

          <Button
            variant="outlined"
            size="small"
            disabled={disabled}
            onClick={handleAddQuestion}
            sx={{ mt: 1 }}
            className="survey-add-row"
          >
            Add row
          </Button>

          <Stack direction="row" spacing={1} justifyContent="flex-end" sx={{ mt: 3 }}>
            <Button type="submit" variant="contained" className="survey-save">
              Save
            </Button>
            <Button variant="outlined" onClick={handleCancel} className="survey-cancel">
              Cancel
            </Button>
          </Stack>
        </form>
      </Paper>

      {newQuestion && (
        <AddQuestion
          editQuestion={editQuestion}
          setEditQuestion={setEditQuestion}
          newQuestion={newQuestion}
          setNewQuestion={setNewQuestion}
          AllQuestionsDropdown={AllQuestionsDropdown}
          questionIndex={questionIndex}
          handleChoicesFromSurvey={handleChoices}
        />
      )}
    </Box>
  );
};
export default CreateSurvey;
